import { Card, CardContent, Grid, Typography, Divider } from "@mui/material";
import { Box } from "@mui/system";

import React, { Component } from "react";

import CircularProgress from '@mui/material/CircularProgress';

import TransactionList from "../transactionList";
import { getURLBase, updateHeightAfterContentUpdate } from "../../../utils/helperFns";
import { Bar, BarChart, Cell } from "recharts";

import axios from "axios";
import Carousel from 'react-material-ui-carousel';
import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';

import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid
} from 'recharts';
import wyzrTheme from "../../../styles/customTheme";

// const MockData = {
//   "data": [
//     {
//       "amt": 124.0,
//       "monthid": 0,
//       "name": "Jun-21",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 52.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 123.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 123.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 51.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 100.0,
//       "monthid": 0,
//       "name": "Jul-21",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 150.0,
//       "monthid": 0,
//       "name": "Aug-21",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 165.0,
//       "monthid": 0,
//       "name": "Sep-21",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 120.0,
//       "monthid": 0,
//       "name": "Oct-21",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 15.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 51.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 28.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 95.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 105.0,
//       "monthid": 0,
//       "name": "Nov-21",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 150.0,
//       "monthid": 0,
//       "name": "Dec-21",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 170.0,
//       "monthid": 0,
//       "name": "Jan-22",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 174.0,
//       "monthid": 0,
//       "name": "Feb-22",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 15.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 51.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 28.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 95.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 195.0,
//       "monthid": 0,
//       "name": "Mar-22",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 15.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 51.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 28.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 95.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 200.0,
//       "monthid": 0,
//       "name": "Apr-22",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 15.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 51.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 28.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 95.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 250.0,
//       "monthid": 0,
//       "name": "May-22",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 15.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 51.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 28.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 95.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     },
//     {
//       "amt": 220.0,
//       "monthid": 0,
//       "name": "Jun-22",
//       "past": {
//         "heading": "Past income",
//         "transactions": [
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 5.0,
//             "date": "7 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 15.0,
//             "date": "14 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 51.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 28.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           },
//           {
//             "amount": 95.0,
//             "date": "21 Feb",
//             "text": "Barik"
//           }
//         ]
//       }
//     }
//   ]

// }

export class AllIncomes extends Component {
  constructor(props) {
    super(props);
    this.url = getURLBase(true) + '/allincomes_new'
    this.state = {
      activeIndex: 0,
      isReady: false,
      currentMonth: null,
      currentName: null,
      width: window.innerWidth,
      currentPage: 0,
      paginatedData: [],
      carouselIndex: 0,
      currentInd: 0

    };
    // Listen to storage event
    window.addEventListener('resize', this.handleWindowSizeChange);
    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
  }

  handleWindowSizeChange = (e) => {
    this.setState({
      width: window.innerWidth
    });
  }


  processGraphData(data) {
    let newData = [];
    for (let i = 0; i < data.length; i++) {
      const month = data[i];
      let obj = {
        "amt": month.amt,
        "name": month.name,
        "monthid": month.monthid,
        "past": month.past
      }
      newData.push(obj);
    }
    return newData;
  }

  renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map(key => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  componentDidMount() {
    axios.post(this.url, { gid: this.props.gid }).then(res => {

      const MONTHS_PER_PAGE = 9;

      const graphData = this.processGraphData(res.data.body.data);

      if (res.data.body.responseStatus === 200) {

        // paginate graph data with 4 months in each page
        let paginatedData = [];
        let currentPageData = [];
        for (let i = 0; i < graphData.length; i++) {
          const month = graphData[i];
          currentPageData.push(month);
          if (currentPageData.length === MONTHS_PER_PAGE) {
            paginatedData.push(currentPageData);
            currentPageData = [];
          }
        }
        if (currentPageData.length > 0) {
          paginatedData.push(currentPageData);
        }

        // get max page number
        let maxPage = paginatedData.length - 1;




        this.setState({
          data: paginatedData[this.state.currentPage],
          transactions: paginatedData[this.state.currentPage][0].past,
          currentName: paginatedData[this.state.currentPage][0].name,
          amt: paginatedData[this.state.currentPage][0].amt,
          graphData: paginatedData[this.state.currentPage],
          maxPage: maxPage,
          paginatedData: paginatedData,
          isReady: true
        });
      }
      else {
        this.setState({
          amt: null,
          isReady: true
        });
      }

      // *************************************** //
      // MOCK DATA

      // const graphData = this.processGraphData(MockData.data);

      // // paginate graph data with 4 months in each page
      // let paginatedData = [];
      // let currentPageData = [];
      // for (let i = 0; i < graphData.length; i++) {
      //   const month = graphData[i];
      //   currentPageData.push(month);
      //   if (currentPageData.length === MONTHS_PER_PAGE) {
      //     paginatedData.push(currentPageData);
      //     currentPageData = [];
      //   }
      // }
      // if (currentPageData.length > 0) {
      //   paginatedData.push(currentPageData);
      // }

      // // get max page number
      // let maxPage = paginatedData.length - 1;

      // this.setState({
      //   data: paginatedData[this.state.currentPage],
      //   transactions: paginatedData[this.state.currentPage][0]?.past,
      //   currentName: paginatedData[this.state.currentPage][0].name,
      //   amt: paginatedData[this.state.currentPage][0].amt,
      //   graphData: paginatedData[this.state.currentPage],
      //   maxPage: maxPage,
      //   paginatedData: paginatedData,
      //   isReady: true,
      // });

      // *************************************** //
    }
    )
  }

  handleClick = (data, index) => {
    console.log("carasoul index", this.state.carouselIndex)
    console.log("selected bar", index)
    this.setState({ activeIndex: index });
    this.setState({
      transactions: this.state.paginatedData[this.state.carouselIndex][index].past,
      amt: this.state.paginatedData[this.state.carouselIndex][index].amt,
      currentName: this.state.paginatedData[this.state.carouselIndex][index].name,
    })
  }


  CustomizedLabel = ({ x, y, value, width, index }) => {
    return (
      <>
        <text x={x + width / 2} y={y} dy="-0.7em" fontSize="0.9rem" fontWeight={600} dominantBaseline={value > 0 ? "text-after-edge" : "text-before-edge"} textAnchor="middle">£{' '}{Math.round(value)}</text>
      </>
    )
  };

  GraphClick = (payload) => {
    let newActiveIndex = (payload.index*4) + payload.index;
    let value;
    if (payload.goingBack) {
      value = -1
    } else {
      value = 1
    }
    this.setState({ activeIndex: newActiveIndex });
    this.setState({
      transactions: this.state.paginatedData[this.state.carouselIndex+value][payload.index].past,
      amt: this.state.paginatedData[this.state.carouselIndex+value][payload.index].amt,
      currentName: this.state.paginatedData[this.state.carouselIndex+value][payload.index].name,
    })

  }

  caraouselChange = (index) => {
    let goingBack = false;
    if (index < this.state.carouselIndex) {
      goingBack = true;
    }
    this.setState({carouselIndex:index});
    this.setState({ activeIndex: 0 });

    this.GraphClick({ index: 0, data: [], goingBack: goingBack });
  }
  render() {
    const Income = () => {
      return (
        <Box width="100%" >
          <CardContent className="p-0">
            <Carousel className="w-100" autoPlay={false} animation="slide"
              index={this.state.carouselIndex}
              navButtonsAlwaysVisible={"auto"} cycleNavigation={false}
              indicators={false}
              onChange={this.caraouselChange}
        
              navButtonsProps={{
                className: "owlNavButton",
                style: {
                  backgroundColor: 'transparent',
                  color: "#82B879",
                  fontSize: 50,
                }
              }}
              navButtonsWrapperProps={{
                className:"incomesCarousel"
              }}
              activeIndicatorIconButtonProps={{
                style: {
                  color: '#82B879'
                }
              }}
              PrevIcon={<ArrowLeftRoundedIcon fontSize="inherit" />}
              NextIcon={<ArrowRightRoundedIcon fontSize="inherit" />}
            >
              {
                this.state.paginatedData.map((item, i) =>
                (
                  <ResponsiveContainer key={i} width="100%" height={500} id="responsecontainerid">
                    <BarChart width="100%" height="100%" data={item} margin={{bottom: 16}}>

                      <CartesianGrid />
                      <XAxis dataKey="name" interval={this.state.width <= 768 ? 2 : 0} bottom={12} />
                      <YAxis></YAxis>
                      <Bar
                        dataKey="amt"
                        fill={wyzrTheme.palette.primary.main}
                        onClick={this.handleClick}
                        
                        barSize={20}
                        //label={this.CustomizedLabel}
                        radius={[10, 10, 0, 0]}
                        isAnimationActive={false}
                        // isAnimationActive={false}
                      >
                        {this.state.graphData.map((entry, index) => (
                          <Cell
                            cursor="pointer"
                            fill={index === this.state.activeIndex ? wyzrTheme.palette.primary.light : entry.inFuture ? wyzrTheme.palette.grey[400] : wyzrTheme.palette.grey[400]}
                            key={`cell-${index}`}
                          />
                        ))}
                      </Bar>
                      {/* <Line dataKey="amt" stroke={wyzrTheme.palette.primary.main}  activeDot={{ onClick: (event, payload) => this.GraphClick(payload) }} isAnimationActive={true} /> */}
                    </BarChart>
                  </ResponsiveContainer>
                ))}
            </Carousel>
          </CardContent>
        </Box>
      );
    };

    const MonthDetails = () => {
      return (
        <Box width={"100%"} margin="auto">
          <CardContent>
            <Typography variant="h5" align="center" gutterBottom>
              {this.state?.transactons?.heading}
            </Typography>
            <TransactionList
              heading={this.state.currentName}
              transactionStatus=""
              prefix="£"
              amount={this.state.amt}
              transactionDetails={
                this.state.transactions
              }
            />
          </CardContent>
        </Box>

      );
    };


    return (
      // <Card className="popup" id="child_AllIncomes" style={{minHeight:"400px"}}>
      <Card className={"widgetCard cardShadow"} id="child_AllIncomes">
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          Income
        </Typography>
        <Divider light />
        <Grid mx={"auto"} px={{md:2,xs:0}} className={`${this.state.isReady ? (`${(this.state.amt === null) ? "blur" : ""}`) : ""}`}>

          <Box>
            {
              this.state.isReady ?
                <CardContent textAlign="center" className="p-0" sx={{padding:0}}>
                  <Grid container rowGap={2} columnSpacing={2} sx={{ "flexDirection": "column" }}>
                    <Grid item md={6} width="100%" sx={{ margin: "auto", maxWidth: "100% !important", paddingRight: "5% !important" }}>
                      <Income />
                    </Grid>
                    <Grid item md={6} width="100%" sx={{ margin: "auto" }}>
                      <MonthDetails />
                    </Grid>
                  </Grid>
                </CardContent>
                : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: "20vh",
                    }}
                  >
                    <CircularProgress color="success" />
                  </Box>
                )
            }
            {updateHeightAfterContentUpdate("parent_Income", "child_AllIncomes")}
          </Box>
        </Grid>
      </Card>
    );
  }
}

export default AllIncomes;